import React from "react";
import { Modal } from "antd";

// Simple syntax highlighter for JSON
function syntaxHighlight(json) {
  if (!json) return "";
  json = JSON.stringify(json, null, 2);
  json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return json.replace(/("(\w+)": )?("[^"]*"|\d+|true|false|null)/g, function (match, p1, p2, p3) {
    let keyColor = "#d19a66";
    let stringColor = "#98c379";
    let numberColor = "#61afef";
    let booleanColor = "#e06c75";
    let nullColor = "#c678dd";
    if (p1) {
      // Key
      return `<span style='color:${keyColor};font-weight:bold;'>${p1}</span>` +
        (p3.startsWith('"')
          ? `<span style='color:${stringColor};'>${p3}</span>`
          : p3 === "true" || p3 === "false"
            ? `<span style='color:${booleanColor};'>${p3}</span>`
            : p3 === "null"
              ? `<span style='color:${nullColor};'>${p3}</span>`
              : `<span style='color:${numberColor};'>${p3}</span>`);
    } else {
      // Value only
      if (match.startsWith('"')) return `<span style='color:${stringColor};'>${match}</span>`;
      if (match === "true" || match === "false") return `<span style='color:${booleanColor};'>${match}</span>`;
      if (match === "null") return `<span style='color:${nullColor};'>${match}</span>`;
      return `<span style='color:${numberColor};'>${match}</span>`;
    }
  });
}

const JsonModal = ({ visible, onClose, title, jsonData }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={title || "JSON Viewer"}
      width={700}
      bodyStyle={{ maxHeight: 500, overflowY: "auto", background: "#f6f8fa" }}
    >
      <pre style={{ fontSize: 14, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
        <code dangerouslySetInnerHTML={{ __html: syntaxHighlight(jsonData) }} />
      </pre>
    </Modal>
  );
};

export default JsonModal;
